import * as React from "react";
import type { SVGProps } from "react";
const SvgFilePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 18 20"
    {...props}
  >
    <path
      fill="#7B4BDD"
      d="M17.03 5.72 11.78.47a.75.75 0 0 0-.53-.22h-9a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-12a.75.75 0 0 0-.22-.53M12 2.81l2.69 2.69H12zm3.75 15.44H2.25V1.75h8.25v4.5a.75.75 0 0 0 .75.75h4.5zm-3.75-6a.75.75 0 0 1-.75.75h-1.5v1.5a.75.75 0 1 1-1.5 0V13h-1.5a.75.75 0 1 1 0-1.5h1.5V10a.75.75 0 0 1 1.5 0v1.5h1.5a.75.75 0 0 1 .75.75"
    />
  </svg>
);
export default SvgFilePlus;
